import { render, staticRenderFns } from "./LooseThreads.vue?vue&type=template&id=f606ebce&"
import script from "./LooseThreads.vue?vue&type=script&lang=js&"
export * from "./LooseThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports